import React from 'react';

const FPVisual = () => {
  return (
    <video className="il-add" data-beta-flow="true" src="/img/fillpower/AF_D-ir_FillPower_720.mp4" muted={true} preload="true" autoPlay={true} loop={true}></video>
  );
};

export { FPVisual };
